const artifactProductionStatuses = {
	NOT_DELIVERED: "not_delivered",
	DELIVERED: "delivered",
	ARCHIVED: "archived",
};

export default artifactProductionStatuses;
